// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__u_yA8","text":"Button_text__3M9Aa","primary":"Button_primary__39VWj","default":"Button_default__3mRnK"};